import { render } from "./StatusBar.vue?vue&type=template&id=3a4cbaee&scoped=true"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"

import "./StatusBar.vue?vue&type=style&index=0&id=3a4cbaee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4cbaee"]])

export default __exports__